import PropTypes from 'prop-types'

const permissions = {
  'view': true,
  'add': false,
  'change': false,
  'delete': false
}

const Permissions = props => {
  try {
    const user = props.store.sessionData.userData
    if (user.role_id === 2) {
      return {
        'view': true,
        'add': true,
        'change': true,
        'delete': true
      }
    }
    const auth_user = user.auth_user
    const user_perms = auth_user.groups[0].permissions
    user_perms.forEach(element => {
      if (element.content_type.model === props.model) {
        let perm = element.codename
        perm = perm.split('_')[0]
        if (perm in permissions) {
          permissions[perm] = true
        }
      }
    })
    return permissions
  } catch (e) {
    return {
      'view': true,
      'add': false,
      'change': false,
      'delete': false
    }
  }
}
Permissions.propTypes = {
  store: PropTypes.object,
  model: PropTypes.string
}

export default Permissions
